import { render, staticRenderFns } from "./UserSetChiefAction.vue?vue&type=template&id=edfda2e4"
import script from "./UserSetChiefAction.vue?vue&type=script&lang=js"
export * from "./UserSetChiefAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports